module.exports = {"serviceName":"Voice Caddie Smart Golf Service","title":"Register a new password.","newPasswordPlaceholder":"Enter a new password","confirmPasswordPlaceholder":"Confirm your new password","resetPassword":"Reset Password"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/ma011.json
// module id = BCf6
// module chunks = 2